<div class="btn-group me-3"
    role="group"
    aria-label="Button group with nested dropdown"
    *ngIf="!dropdownOnly && actions.length && user && user.role && user.role.name && roles && roles.includes(user.role.name)"
>
    <ng-container *ngFor="let action of actions | slice:0:dropdownStartFrom">
        <a  [routerLink]="action?.link" *ngIf="action?.link && user && user.role && user.role.name && (action?.roles ? action?.roles?.includes(user.role.name) : true)"
            [queryParams]="action?.queryParams"
            class="btn btn-primary"
            [class.btn-sm]="smallButtons"
            [class.disabled]="action?.disabled"
        >
            <i [class]="(action?.icon || defaultEmptyIcon) + ' fa-fw'"></i>
            <span class="d-none d-md-inline">  {{ action?.text }} </span>
        </a>

        <button *ngIf="!action?.link && user && user.role && user.role.name && (action?.roles ? action?.roles?.includes(user.role.name) : true)"
                (click)="onButtonClicked(action?.id ?? action?.text ?? '')"
                class="btn btn-primary"
                [class.btn-sm]="smallButtons"
                [class.disabled]="action?.disabled"
                [attr.disabled]="action?.disabled ? true : null"
        >
            <i [class]="(action?.icon || defaultEmptyIcon) + ' fa-fw'"></i> <span class="d-none d-md-inline"> {{ action?.text }} </span>
        </button>
    </ng-container>

    <div class="btn-group" role="group" *ngIf="actions.length > dropdownStartFrom">
        <ng-container   [ngTemplateOutlet]="dropdown"
                        [ngTemplateOutletContext]="{actions: actions | slice:dropdownStartFrom, user: user}">
        </ng-container>
    </div>
</div>

<ng-container   *ngIf="dropdownOnly"
                [ngTemplateOutlet]="dropdown"
                [ngTemplateOutletContext]="{actions: actions, user: user}">
</ng-container>

<ng-template #dropdown  let-actions="actions" let-user="user">
    <button type="button"
            class="btn {{ dropdownClass }} dropdown-toggle"
            [class.btn-sm]="smallButtons" data-bs-toggle="dropdown" aria-expanded="false"
    >
        <i *ngIf="dropdownIcon?.length" class="fa-solid fa-fw fa-lg" [ngClass]="dropdownIcon"></i>

        {{ dropdownButtonText }}
    </button>
    <ul class="dropdown-menu">
        <ng-container *ngFor="let action of actions">
            <li *ngIf="!action?.hide">
                <a [routerLink]="action?.link" *ngIf="action?.link && (action?.roles ? action?.roles?.includes(user?.role?.name ?? '') : true)"
                    [queryParams]="action?.queryParams"
                    class="dropdown-item btn btn-primary btn-sm rounded-0"
                    [class.disabled]="action?.disabled"
                >
                    <i [class]="(action?.icon || defaultEmptyIcon) + ' fa-fw'"></i>
                    {{ action?.text }}
                </a>

                <button *ngIf="action && !action?.link && action?.text && !action?.header  && (action?.roles ? action?.roles?.includes(user?.role?.name ?? '') : true)"
                        class="dropdown-item btn btn-primary btn-sm rounded-0"
                        (click)="onButtonClicked(action?.id ?? action?.text)"
                        [class.disabled]="action?.disabled"
                        [attr.disabled]="action?.disabled ? true : null"

                >
                    <i [class]="(action?.icon || defaultEmptyIcon) + ' fa-fw'"></i>

                    {{ action?.text }}
                </button>

                <hr *ngIf="action?.divider" class="dropdown-divider">

                <span *ngIf="action?.header" class="dropdown-header">
                    {{ action?.text }}
                </span>
            </li>
        </ng-container>
    </ul>
</ng-template>
